import { ButtonColorVariant, ButtonSize, ButtonVariant, Modal, useMedia } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import { useNavigation } from "@/hooks";

interface IDiscardChangesModalProps {
  heading: string;
  handleClose: () => void;
  onUserConfirmation: () => void;
  isVisible: boolean;
  description?: string;
}

const DiscardChangesModalV2 = ({
  heading,
  onUserConfirmation,
  handleClose,
  isVisible,
  description = "It looks like you have unsaved changes in your character form. Would you like to save your progress before leaving?",
}: IDiscardChangesModalProps) => {
  const { isMobile, isDesktop } = useMedia();
  const { isSideNavOpen } = useNavigation();
  const { t } = useTranslation();
  const handleCloseModal = () => {
    onUserConfirmation();
  };

  return (
    <Modal
      title={heading}
      aria-labelledby="confirmation modal"
      open={isVisible}
      onOpenChange={handleClose}
      description={description}
      className={isDesktop ? (isSideNavOpen ? "ml-[110px]" : "ml-[25px]") : ""}
      verticalButtons={isMobile}
      actions={[
        { label: t("chatbot:modal.unsavedChanges.cancel"), onClick: handleClose, variant: ButtonVariant.OUTLINED, size: ButtonSize.LARGE },
        { label: t("chatbot:modal.unsavedChanges.discard"), onClick: handleCloseModal, size: ButtonSize.LARGE, color: ButtonColorVariant.ERROR },
      ]}
    />
  );
};

export default DiscardChangesModalV2;
